// Role helpers shared across the app
export const MANAGER_ROLES = ['admin', 'manager', 'agency', 'talent_manager', 'campaign_manager'];

export const isManagerRole = (user) => !!user && MANAGER_ROLES.includes(user.role);
export const isAdmin = (user) => user?.role === 'admin';
export const isBrand = (user) => user?.role === 'brand';
export const isCreator = (user) => user?.role === 'creator';
export const isTalentManager = (user) => user?.role === 'talent_manager';
export const isCampaignManager = (user) => user?.role === 'campaign_manager';

export const roleLabel = (role) => {
  if (!role) return '';
  return role.split('_').map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
};
